<template lang='pug'>
v-content
  v-app-bar( v-if='$sesion' color='light-green accent-4')
    v-toolbar-title CMS 
    v-spacer
    v-btn(icon @click='drawer=!drawer' color=red)
      v-icon fa-bars
  router-view
  v-overlay( :value='cargando' )
    v-progress-circular( indeterminate color="white")
  v-navigation-drawer.light-green.accent-4(app dark  mini-variant expand-on-hover v-model='drawer' )
    v-list
      v-list-item(v-for='{texto, icono, ruta} in menu' :key='texto' link :to='ruta')
        v-list-item-icon
          v-icon {{ icono }}
        v-list-item-content
          v-list-item-title {{ texto }}
    template(v-slot:append)
      v-list-item( @click='cerrar_sesion()')
        v-list-item-icon
          v-icon fa-sign-out
        v-list-item-content
          v-list-item-title Cerrar sesión

</template>
<script>
import { mapActions } from 'vuex'
export default {
  data: ()=>({
    drawer: false,
    menu: [
      { texto: 'Contenido', icono: 'fa-sitemap', ruta: {name: 'contenido_cms'} },
      { texto: 'Blog', icono: 'far fa-newspaper', ruta: {name: 'blog_cms'} },
      { texto: 'Galería', icono: 'far fa-images', ruta: {name: 'galeria_cms'} },
      { texto: 'Registro de correos', icono: 'fas fa-envelope', ruta: {name: 'registro_de_correos_cms'}}
    ]
  }),
  methods: {
    ...mapActions({
      cerrar_sesion: 'Sesion/cerrar_sesion',
    })
  }
}
</script>